import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ContractForm from '../components/ContractForm';

// ─────────────────────────────────────────────
// 계약서 수정 화면
//  입력 폼은 ContractForm(공용)을 사용한다
//  → 필드가 늘어도 ContractForm 한 곳만 고치면 등록/수정 양쪽에 반영된다
// ─────────────────────────────────────────────

export default function ContractEdit() {
  const { id } = useParams();
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchContract();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchContract = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`/api/contracts/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setContract(res.data.data);
    } catch (e) {
      alert('계약서 조회 실패');
      window.location.href = '/contracts/list';
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!window.confirm('계약서를 수정하시겠습니까?')) return;

    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(`/api/contracts/${id}`, contract, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        alert('계약서가 수정되었습니다! ✅');
        window.location.href = `/contracts/${id}`;
      }
    } catch (e) {
      alert('수정 실패: ' + (e.response?.data?.message || e.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: '20px' }}>로딩 중...</div>;
  if (!contract) return <div style={{ padding: '20px' }}>계약서를 찾을 수 없습니다</div>;

  const btn = (bg) => ({
    backgroundColor: bg, color: 'white', border: 'none',
    padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px',
  });

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '20px', margin: 0 }}>✏️ 계약서 수정</h1>
        {/* 버튼 묶음은 화면 우상단에 고정 — 스크롤과 무관하게 항상 접근 가능 */}
        <div style={{
          display: 'flex', gap: '8px',
          position: 'fixed', top: '130px', right: '20px', zIndex: 1000,
          backgroundColor: 'rgba(255,255,255,0.95)',
          padding: '8px', borderRadius: '6px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}>
          <button onClick={() => (window.location.href = `/contracts/${id}`)} style={btn('#757575')}>
            ❌ 취소
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{ ...btn(saving ? '#ccc' : '#4CAF50'), cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            {saving ? '저장 중...' : '💾 저장'}
          </button>
        </div>
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
        {/* 공용 입력 폼 — 담당측은 상세보기 SMS 패널에서 관리하므로 여기선 숨김 */}
        <ContractForm
          value={contract}
          onChange={setContract}
          showOurSide={false}
        />
      </div>


    </div>
  );
}
